import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/chargeItem/list',
    method: 'post',
    data: data
  });
}
export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/chargeItem/delete',
    method: 'post',
    data: data
  });
}
export function getDetail(data) {
  return request({
    url: '/pmsservice/api/chargeItem/get',
    method: 'post',
    data: data
  });
}
export function getChargeItem(data) {
  return request({
    url: '/pmsservice/api/chargeItem/getChargeItem',
    method: 'post',
    data: data
  });
}
export function insert(data) {
  return request({
    url: '/pmsservice/api/chargeItem/insert',
    method: 'post',
    data: data
  });
}
export function update(data) {
  return request({
    url: '/pmsservice/api/chargeItem/update',
    method: 'post',
    data: data
  });
}